/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  Form,
  Row,
  Spin,
} from 'antd';
import { getCategoriasDeVariables } from 'api/configuracion';
import { getValoresPorVariablesDeSeleccion } from 'api/configuracion/valoresPorVariablesDeSeleccion';
import { getVariable, getVariables } from 'api/configuracion/variables';
import Variables from 'views/Tramites/GPM/components/Variables';
import NumericInput from 'components/NumericInput';
import Select from 'components/Select';
import React, { useEffect, useMemo, useState } from 'react';
import toCurrency from 'utils/toCurrency';
import { aplicacionesCargosEnum } from 'views/Tramites/GPM/enums';

const FormGasto = ({
  formGasto,
  tiposDeGastos,
  rules,
  selectedRowKeysGastos,
  onFinishGasto,
  setVariables,
  variables,
  isEdit,
}) => {
  const [catalogoDeVariables, setCatalogoDeVariables] = useState([]);
  const [categoriasDeVariables, setCategoriasDeVariables] = useState([]);
  const [variablesOptions, setVariablesOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const tipoDeGastoId = Form.useWatch('tipo_de_gasto', formGasto);
  const tipoDeGasto = useMemo(() => tiposDeGastos.find((e) => e.id === tipoDeGastoId),
    [tiposDeGastos, tipoDeGastoId]);

  const tipoDeAplicacion = tipoDeGasto?.tipo_de_aplicacion;

  const getTooltip = () => {
    // Si no hay tipo de gasto seleccionado, no mostrar tooltip
    if (!tipoDeGasto) {
      return undefined;
    }

    const { tipo_de_aplicacion, importe_minimo, importe_maximo } = tipoDeGasto;

    // Solo mostrar tooltip si no hay filas seleccionadas
    if (selectedRowKeysGastos.length > 0) {
      return undefined;
    }

    let title;
    switch (tipo_de_aplicacion) {
      case aplicacionesCargosEnum.CAPTURABLE:
        // Validar que existan los valores antes de formatearlos
        if (importe_minimo && importe_maximo) {
          title = `Mínimo ${toCurrency(importe_minimo)}, Máximo ${toCurrency(importe_maximo)}`;
        } else {
          title = 'Importe capturable';
        }
        break;
      case aplicacionesCargosEnum.FIJO:
        title = 'Importe fijo tomado del tipo de gasto';
        break;
      case aplicacionesCargosEnum.FORMULA:
        title = 'Importe calculado por la fórmula al guardar';
        break;
      default:
        return undefined;
    }

    return { title };
  };

  const handleFormulaOrSqlFunction = async (record) => {
    setLoading(true);
    if (record?.variables?.length) {
      const [
        _catalogosDeVariables,
        _variables,
        _variablesOptions,
        _categoriasDeVariables,
      ] = await Promise.all([
        getVariables(),
        Promise.all(record.variables.map((e) => getVariable(e))),
        getValoresPorVariablesDeSeleccion(),
        getCategoriasDeVariables(),
      ]);

      setVariables(_variables);
      setCatalogoDeVariables(_catalogosDeVariables);
      setCategoriasDeVariables(_categoriasDeVariables);
      setVariablesOptions(_variablesOptions);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tipoDeAplicacion === aplicacionesCargosEnum.FORMULA) {
      handleFormulaOrSqlFunction(tipoDeGasto);
    }
  }, [tipoDeAplicacion]);

  return (
    <Form
      layout="vertical"
      name="gasto"
      form={formGasto}
      onFinish={() => {
        onFinishGasto();
      }}
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            name="tipo_de_gasto"
            label="Tipo de gasto"
            rules={rules.required}
          >
            <Select
              dataSource={tiposDeGastos}
              keyLabelRender
              disabled={isEdit}
              onChange={(id) => {
                const _tipoDeGasto = tiposDeGastos.find((e) => e.id === id);
                if (_tipoDeGasto.tipo_de_aplicacion === aplicacionesCargosEnum.FIJO) {
                  formGasto.setFieldsValue({ importe: _tipoDeGasto.importe });
                }
              }}
            />
          </Form.Item>
        </Col>
        {tipoDeAplicacion === aplicacionesCargosEnum.CAPTURABLE && (
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              name="importe"
              label="Importe"
              tooltip={getTooltip()}
              rules={rules.importe}
              decimal
            />
          </Col>
        )}
        {tipoDeAplicacion === aplicacionesCargosEnum.FIJO && (
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              name="importe"
              label="Importe"
              rules={rules.importe}
              allowZero
              disabled
              value={tipoDeGasto?.importe}
              decimal
            />
          </Col>
        )}
      </Row>
      {tipoDeAplicacion === aplicacionesCargosEnum.FORMULA && (
        <Spin spinning={loading} tip="Cargando variables...">
          <Row gutter={10}>
            <Variables
              catalogoDeVariables={catalogoDeVariables}
              variables={variables.map((e) => e.id)}
              valoresDeVariablesDeSelecion={variablesOptions}
              categoriasDeVariables={categoriasDeVariables}
            />
          </Row>
        </Spin>
      )}
      <Form.Item hidden>
        <Button htmlType="submit" />
      </Form.Item>
    </Form>
  );
};

export default FormGasto;
